// Sort-related constants
export const SORT_ORDERS = {
  ASC: 'asc',
  DESC: 'desc',
};

// Cards sort options
export const CARDS_SORT_OPTIONS = {
  RECENT_DESC: 'recentDesc',
  RECENT_ASC: 'recentAsc',
  POSITION_DESC: 'positionDesc',
  POSITION_ASC: 'positionAsc',
  LAST_15_DESC: 'last15Desc',
  LAST_15_ASC: 'last15Asc',
};

// Scores sort options
export const SCORES_SORT_OPTIONS = {
  LAST_5: 'last5',
  LAST_10: 'last10',
  // Last-10-*played* (Sorare's headline L10): a played-only window, so it is NOT
  // interchangeable with LAST_10. Football only — NBA has no counterpart.
  LAST_10_PLAYED: 'last10p',
  LAST_15: 'last15',
  LAST_20: 'last20',
  LAST_30: 'last30',
  LAST_40: 'last40',
  ALL: 'all',
  GAME_WEEK: 'gameWeek',
  DIFF: 'diff',
  // `as const` so the values keep their literal types: `Scores.tsx` indexes
  // `FootballScoresData` with them, which is what turns a mistyped span name here into a
  // compile error instead of a block that silently never renders.
} as const;

// NBA scores sort options
export const NBA_SCORES_SORT_OPTIONS = {
  GAME_WEEK: 'gameWeek',
  DIFF: 'diff',
  LAST_10: 'last10',
  LAST_20: 'last20',
  LAST_40: 'last40',
  ALL: 'all',
};

// NBA lineup sort options
export const NBA_LINEUP_SORT_OPTIONS = {
  DIFF: 'diff',
  LAST_10: 'last10',
  GAME_WEEK: 'gameWeek',
};

// Default sort values
export const DEFAULT_CARDS_SORT = CARDS_SORT_OPTIONS.RECENT_DESC;
export const DEFAULT_SCORES_SORT = SCORES_SORT_OPTIONS.LAST_15;
export const DEFAULT_NBA_SCORES_SORT = NBA_SCORES_SORT_OPTIONS.GAME_WEEK;
export const DEFAULT_NBA_LINEUP_SORT = NBA_LINEUP_SORT_OPTIONS.DIFF;
